// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.__teamAlerts{
  display: grid;
  grid-template-columns: 310px 1fr;
  font-size: 1.8rem;
  height: 100%;
  margin-top: 5px;
  gap: 12px;
}
@media (min-height: 768px) {
  .__teamAlerts{
    display: grid;
    grid-template-columns: 310px 1fr;
    font-size: 1.8rem;
    height: calc(100vh - 120px);
    margin-top: 5px;
    gap: 12px;
  }
}
.__teamAlerts__filters{
  box-shadow: 0px 4.8px 14.4px rgba(0, 0, 0, 0.18);
  border-radius: 4px;
  text-align: left;
  background: #ffffff;
  height: fit-content;
  padding-bottom: 8px;
}
.__teamAlerts__grid{
  box-shadow: 0px 4.8px 14.4px rgba(0, 0, 0, 0.18);
  border-radius: 4px;
  text-align: left;
  background: #ffffff;
  height: fit-content;
  overflow-x: auto;
  overflow-y: hidden;
  min-width: 0;
  position: relative;
}
.__teamAlerts__grid--container{
  padding-bottom: 1px;
}
.__teamAlerts__grid--container-title{
  font-weight: 600;
  font-size: var(--title);
  line-height: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #000;
  margin: 0;
  padding: 10px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.__teamAlerts__grid--switch-container {
  margin: 0;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding: 6px 12px;
}
.__teamAlerts__grid--switch-title {
  color: var(--primary);
  font-weight: 500;
  font-size: var(--subheader);
  margin: 0;
  margin-right: 10px;
  white-space: nowrap;
}
@media (min-height: 768px) {
  .__teamAlerts__grid--container-title{
    font-family: Segoe UI;
    font-weight: 600;
    font-size: var(--subheader);
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #000;
    margin: 0;
    padding: 10px 12px;
  }
}
.__teamAlerts__grid--container-freeAcion{
  display: flex;
  align-items: flex-end;
}
.__teamAlerts__grid--container-dateRange{
  margin-right: 12px;
  font-size: var(--subheader);
  display: flex;
  align-items: center;
}
.__teamAlerts__grid--container-dateRange-title {
  margin: 0 8px;
}

.refresh-body {
  font-weight: bold;
  font-family: 'Segoe UI';
  margin-bottom: 5%;
}

:root {
  --toastify-color-light: #2B3B42;
  --toastify-text-color-light: #FFF;
}

.subscribe-button {
  background-color: var(--primary) !important;
  border-radius: 0.15rem !important;
  width: 9rem !important;
}
.subscribe-button .MuiButton-label {
  color: #FFF;
  text-transform: capitalize;
  font-size: var(--caption);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.subscribe-button:hover {
  background-color: #0073E5 !important;
}

.MuiTooltip-tooltip {
  height: 2.2rem;
  background-color: #f8f8f8 !important;
  border-radius: 1px !important;
  box-shadow: -2px 4px 5px 0px rgba(0,0,0,0.75);
}
.subscribe-tooltip {
  color: black;
  margin-top: 0.45rem;
}

/* Override toastify css classes */
.Toastify__toast-container--top-right {
  position: fixed !important;
  top: 70px !important;
  right: 16px !important;
  z-index: 9999;
  width: auto;
  max-width: 260px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modules/TeamAlerts/TeamAlerts.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,SAAS;AACX;AACA;EACE;IACE,aAAa;IACb,gCAAgC;IAChC,iBAAiB;IACjB,2BAA2B;IAC3B,eAAe;IACf,SAAS;EACX;AACF;AACA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,4CAA4C;EAC5C,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,qBAAqB;IACrB,gBAAgB;IAChB,2BAA2B;IAC3B,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,kBAAkB;EACpB;AACF;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;EAC3C,iCAAiC;EACjC,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,0BAA0B;EAC1B,yBAAyB;EACzB,4DAA4D;AAC9D;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,6BAA6B;EAC7B,6CAA6C;AAC/C;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".__teamAlerts{\n  display: grid;\n  grid-template-columns: 310px 1fr;\n  font-size: 1.8rem;\n  height: 100%;\n  margin-top: 5px;\n  gap: 12px;\n}\n@media (min-height: 768px) {\n  .__teamAlerts{\n    display: grid;\n    grid-template-columns: 310px 1fr;\n    font-size: 1.8rem;\n    height: calc(100vh - 120px);\n    margin-top: 5px;\n    gap: 12px;\n  }\n}\n.__teamAlerts__filters{\n  box-shadow: 0px 4.8px 14.4px rgba(0, 0, 0, 0.18);\n  border-radius: 4px;\n  text-align: left;\n  background: #ffffff;\n  height: fit-content;\n  padding-bottom: 8px;\n}\n.__teamAlerts__grid{\n  box-shadow: 0px 4.8px 14.4px rgba(0, 0, 0, 0.18);\n  border-radius: 4px;\n  text-align: left;\n  background: #ffffff;\n  height: fit-content;\n  overflow-x: auto;\n  overflow-y: hidden;\n  min-width: 0;\n  position: relative;\n}\n.__teamAlerts__grid--container{\n  padding-bottom: 1px;\n}\n.__teamAlerts__grid--container-title{\n  font-weight: 600;\n  font-size: var(--title);\n  line-height: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: #000;\n  margin: 0;\n  padding: 10px 12px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n}\n.__teamAlerts__grid--switch-container {\n  margin: 0;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  padding: 6px 12px;\n}\n.__teamAlerts__grid--switch-title {\n  color: var(--primary);\n  font-weight: 500;\n  font-size: var(--subheader);\n  margin: 0;\n  margin-right: 10px;\n  white-space: nowrap;\n}\n@media (min-height: 768px) {\n  .__teamAlerts__grid--container-title{\n    font-family: Segoe UI;\n    font-weight: 600;\n    font-size: var(--subheader);\n    line-height: 20px;\n    display: flex;\n    align-items: center;\n    color: #000;\n    margin: 0;\n    padding: 10px 12px;\n  }\n}\n.__teamAlerts__grid--container-freeAcion{\n  display: flex;\n  align-items: flex-end;\n}\n.__teamAlerts__grid--container-dateRange{\n  margin-right: 12px;\n  font-size: var(--subheader);\n  display: flex;\n  align-items: center;\n}\n.__teamAlerts__grid--container-dateRange-title {\n  margin: 0 8px;\n}\n\n.refresh-body {\n  font-weight: bold;\n  font-family: 'Segoe UI';\n  margin-bottom: 5%;\n}\n\n:root {\n  --toastify-color-light: #2B3B42;\n  --toastify-text-color-light: #FFF;\n}\n\n.subscribe-button {\n  background-color: var(--primary) !important;\n  border-radius: 0.15rem !important;\n  width: 9rem !important;\n}\n.subscribe-button .MuiButton-label {\n  color: #FFF;\n  text-transform: capitalize;\n  font-size: var(--caption);\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n.subscribe-button:hover {\n  background-color: #0073E5 !important;\n}\n\n.MuiTooltip-tooltip {\n  height: 2.2rem;\n  background-color: #f8f8f8 !important;\n  border-radius: 1px !important;\n  box-shadow: -2px 4px 5px 0px rgba(0,0,0,0.75);\n}\n.subscribe-tooltip {\n  color: black;\n  margin-top: 0.45rem;\n}\n\n/* Override toastify css classes */\n.Toastify__toast-container--top-right {\n  position: fixed !important;\n  top: 70px !important;\n  right: 16px !important;\n  z-index: 9999;\n  width: auto;\n  max-width: 260px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
